import styled from "styled-components";

export const PathwayTable = styled.div`
    display: grid;
    row-gap: var(--gap-m);
`;

export const PathwayTableHeaderRow = styled.div`
    display: grid;
    grid-auto-rows: 1fr;
    border-bottom: 0.15rem solid #c8ced3;
    column-gap: var(--gap-m);
    font-weight: bolder;
`;

const TableCell = styled.div`
    & > p {
        margin: 0;
        padding: 0;
    }
`;

export const PathwayTableContentRow = styled.div`
    display: grid;
    column-gap: var(--gap-m);
`;

export const PathwayTableContentRowFontRegular = styled(PathwayTableContentRow)`
    font-weight: lighter;
`;

export const PathwayTableTwoCellsRow = styled(PathwayTableContentRow)`
    grid-template-columns: 50fr 50fr;
`;

export const PathwayTableHeader = styled(TableCell)`
    display: grid;
    font-weight: bold;
    align-content: center;
    align-self: center;
    row-gap: var(--gap-s);
`;

export const PathwayCenteredTableHeader = styled(PathwayTableHeader)`
    text-align: center;
`;

export const PathwayTableCellContent = styled(TableCell)`
    display: grid;
    align-content: center;
    align-self: center;
    row-gap: var(--gap-s);
`;

export const PathwayCenteredTableCellContent = styled(PathwayTableCellContent)`
    text-align: center;
`;

export const PathwayLeftAlignTableCellContent = styled(PathwayTableCellContent)`
    text-align: left;
`;

export const TableContentDividerLine = styled.div`
    display: grid;
    border-bottom: 0.1rem solid #c8ced3;
`;

export const TableHeaderLine = styled.div`
    border-bottom: 0.15rem solid #c8ced3;
`;

export const AlignRightHeaderCell = styled(TableCell)`
    text-align: right;
    font-weight: bold;
`;

export const AlignLeftHeaderCell = styled(TableCell)`
    text-align: left;
    font-weight: bold;
`;

export const AlignRightCell = styled(TableCell)`
    text-align: right;
`;

export const AlignLeftCell = styled(TableCell)`
    text-align: left;
`;
